import { computed, onMounted } from 'vue';

import { marketService, MarketModel, MarketState } from '@exchange/libs/market/service/src';
import { MyOrdersListType } from '@exchange/libs/order/shared-model/src/lib/order-essentials';
import type { OrderWithTradesModel } from '@exchange/libs/order/shared-model/src/lib/order-model';
import { settingsService } from '@exchange/libs/settings/service/src';

const useOrder = (order: OrderWithTradesModel, type: MyOrdersListType) => {
  const { markets } = marketService;
  const market = computed<MarketModel | undefined>(() => markets.value[order.instrumentCode]);
  const marketIsSuspended = computed(() => Boolean(market.value?.stateIs(MarketState.SUSPENDED)));
  const marketIsInMaintenance = computed(() => Boolean(market.value?.stateIs(MarketState.IN_MAINTENANCE)));

  const myOrdersSettings = computed(() => settingsService.settings.userSettings.myOrdersSettings);
  const showTimestamp = computed(() => Boolean(myOrdersSettings.value.showTimestamp));

  const animation = computed(() => order.animation);

  onMounted(() => {
    order.animationPlay(order.status, type);
  });

  return {
    animation,
    market,
    marketIsInMaintenance,
    marketIsSuspended,
    myOrdersSettings,
    showTimestamp,
  };
};

export default useOrder;
